import { render, staticRenderFns } from "./UserMenuBtn.vue?vue&type=template&id=3ef58688"
import script from "./UserMenuBtn.vue?vue&type=script&lang=js"
export * from "./UserMenuBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports